import { render, staticRenderFns } from "./BugCommitDetail.vue?vue&type=template&id=003baf2e&scoped=true&"
import script from "./BugCommitDetail.vue?vue&type=script&lang=js&"
export * from "./BugCommitDetail.vue?vue&type=script&lang=js&"
import style0 from "./BugCommitDetail.vue?vue&type=style&index=0&id=003baf2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003baf2e",
  null
  
)

export default component.exports